var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cell position", class: "cell__" + _vm.column },
    [
      _vm.column === "worker"
        ? [
            _c(
              "div",
              { staticClass: "position__name" },
              [
                _c("c-button2", {
                  staticClass: "position__add-workers",
                  attrs: {
                    id: "add-workers-" + _vm.position.code,
                    size: "small",
                    icon: {
                      icon: "plus-bold",
                      color: "primary",
                    },
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("addWorkers")
                    },
                  },
                }),
                _c(
                  "b-popover",
                  {
                    attrs: {
                      placement: "top",
                      triggers: "hover",
                      target: "add-workers-" + _vm.position.code,
                    },
                  },
                  [_vm._v(" Добавить сотрудников ")]
                ),
                _vm._v(" " + _vm._s(_vm.position.name) + " "),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.column === "totalShifts"
        ? [
            _c("div", { staticClass: "shifts" }, [
              _vm.data.dayShiftsCount || _vm.data.calcDayShiftsCount
                ? _c("div", [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 12 12",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M9 5.99976C9 7.65661 7.65685 8.99976 6 8.99976M9 5.99976C9 4.3429 7.65685 2.99976 6 2.99976M9 5.99976H11M6 8.99976C4.34315 8.99976 3 7.65661 3 5.99976M6 8.99976V10.9998M3 5.99976C3 4.3429 4.34315 2.99976 6 2.99976M3 5.99976H1M6 2.99976V0.999756M8.5 3.49976L9.53555 2.46421M2.46448 9.53528L3.50003 8.49973M3.50003 3.49976L2.46449 2.46421M9.53555 9.53528L8.5 8.49973",
                            stroke: "#BFC9E0",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                    _vm._v(
                      " " +
                        _vm._s(_vm.data.dayShiftsCount) +
                        "/" +
                        _vm._s(_vm.data.calcDayShiftsCount) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _vm.data.nightShiftsCount || _vm.data.calcNightShiftsCount
                ? _c("div", [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "10",
                          viewBox: "0 0 10 10",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M4.21206 0.999756C2.26415 1.45382 0.874839 3.22915 1.00894 5.24767C1.07574 6.25324 1.37442 7.05834 2.15788 7.84182C2.94136 8.62532 3.74651 8.92401 4.75209 8.99082C6.77061 9.12492 8.54593 7.7356 9 5.7877C7.63077 6.11214 6.1456 6.09475 5.02529 4.97442C3.90499 3.85409 3.88761 2.36899 4.21206 0.999756Z",
                            stroke: "#BFC9E0",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                    _vm._v(
                      " " +
                        _vm._s(_vm.data.nightShiftsCount) +
                        "/" +
                        _vm._s(_vm.data.calcNightShiftsCount) +
                        " "
                    ),
                  ])
                : _vm._e(),
              !_vm.data.dayShiftsCount &&
              !_vm.data.nightShiftsCount &&
              !_vm.data.calcDayShiftsCount &&
              !_vm.data.nightShiftsCount
                ? _c("div", [_vm._v(" 0 ")])
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
      _vm.column === "workTime"
        ? [
            _c("div", { staticClass: "work-time" }, [
              _c("div", [
                _vm._v(_vm._s(_vm.formatTime(_vm.data.totalTimeMin))),
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.formatTime(_vm.data.calcTotalTimeMin))),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm.column === "compensation"
        ? [
            _vm._v(
              " " + _vm._s((_vm.data.compensation || 0).toLocaleString()) + " "
            ),
          ]
        : _vm._e(),
      _vm.column === "load"
        ? [_vm._v(" " + _vm._s((_vm.data.load || 0).toLocaleString()) + " ")]
        : _vm._e(),
      _vm.column === "salary"
        ? [_vm._v(" " + _vm._s((_vm.data.salary || 0).toLocaleString()) + " ")]
        : _vm._e(),
      _vm.column === "salaryMainPart"
        ? [
            _c("div", { staticClass: "salary-main" }, [
              _c("div", [
                _vm._v(
                  _vm._s(Math.floor(_vm.data.salaryMain || 0).toLocaleString())
                ),
              ]),
              _c("div", [
                _vm._v(
                  _vm._s(
                    Math.floor(_vm.data.calcSalaryMain || 0).toLocaleString()
                  )
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm.column === "excessPremium"
        ? [
            _vm._v(
              " " + _vm._s((_vm.data.excessPremium || 0).toLocaleString()) + " "
            ),
          ]
        : _vm._e(),
      _vm.column === "Depreciation"
        ? [
            _vm._v(
              " " + _vm._s((_vm.data.depreciation || 0).toLocaleString()) + " "
            ),
          ]
        : _vm._e(),
      _vm.column === "premium"
        ? [_vm._v(" " + _vm._s((_vm.data.premium || 0).toLocaleString()) + " ")]
        : _vm._e(),
      _vm.column === "fine"
        ? [_vm._v(" " + _vm._s((_vm.data.fine || 0).toLocaleString()) + " ")]
        : _vm._e(),
      _vm.column === "penalties"
        ? [
            _vm._v(
              " " + _vm._s((_vm.data.penalties || 0).toLocaleString()) + " "
            ),
          ]
        : _vm._e(),
      _vm.column === "totalAccrued"
        ? [
            _vm._v(
              " " + _vm._s((_vm.data.totalAccrued || 0).toLocaleString()) + " "
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }